import * as React from "react";

import type { UserSessionContextPayload } from "./types";

const UserSessionContext = React.createContext({} as UserSessionContextPayload);

export const UserSessionProvider = UserSessionContext.Provider;

/**
 * Exposes the User Session functions
 */
export const useUserSession = (): UserSessionContextPayload => {
  const context = React.useContext(UserSessionContext);

  if (!context) {
    throw new Error("useUserSession should be used within UserSessionProvider");
  }

  return context;
};
